module.exports = __webpack_public_path__ + "static/media/good.a143c57d.png";